export const LOGOUT_MUTATION = `
  mutation LogoutMutation {
    me {
      logout
    }
  }
`;
